<!-- 评价管理 -->
<template>
  <div class="container">
    <header class="header">
      <div class="leftBox">
        <p class="p1">机构账户认证信息</p>
        <p class="p2">
          <span class="span1">认证身份：机构用户（旅行社）</span>
          <span class="span2">权限查看</span>
        </p>
        <div style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0.12rem;
          ">
          <p class="p3">资质信息：<span>待认证</span></p>
          <p class="p4">资质信息：<span>待认证</span></p>
        </div>
        <p class="p2">
          <span class="span1">机构名称：无</span>
          <span @click="handlerModifyPasswordClick" class="span2">修改密码</span>
        </p>
        <p class="p2">
          <span class="span1">绑定手机：13910581028</span>
          <span @click="handlerModifyApplyClick" class="span2">改绑申请</span>
        </p>
        <p class="p2">
          <span class="span1">法定代表：无</span>
        </p>
        <p class="p2">
          <span class="span1">员工账号：无</span>
          <span class="span2">维护员工账号</span>
        </p>
      </div>
      <div class="rightBox">
        <div style="width: 45%">
          <p class="p1">平台认证</p>
          <p class="p2">
            <span class="span1" style="font-weight: bold">定制师中心：未上线</span>
            <span class="span2">设置</span>
          </p>
          <p class="p2">
            <span class="span1">认证身份：平台普通用户</span>
          </p>
          <p class="p2">
            <span class="span1">机构名称：无</span>
            <span class="span2">查看</span>
          </p>
          <p class="p2">
            <span class="span1">认证有效期：无</span>
            <span class="span2">查看</span>
          </p>
        </div>
      </div>
    </header>
    <footer class="footer">
      <div class="left">
        <div class="lineBox">
          <div class="line1">
            <img style="margin-right: 0.1rem" :src="require('@/assets/png/img.png')" />
            <div>
              <p class="p1">门店 <span>LV1</span></p>
              <p class="p2">当前等级已享9项基本权益</p>
            </div>
          </div>
          <el-button size="small" class="btns" plain>升级</el-button>
        </div>
        <div class="lineBox">
          <div style="display: flex; align-items: center">
            <p class="p3 p4">有效期：</p>
            <p class="p3">一直有效</p>
          </div>
          <el-button size="small" class="btns" plain>延期</el-button>
        </div>
        <div class="lineBox" style="margin-bottom: 0.2rem">
          <div>
            <div style="display: flex; align-items: center; margin-bottom: 0.1rem">
              <div style="
                  display: flex;
                  align-items: center;
                  margin-right: 0.24rem;
                ">
                <p class="p3 p4">累计充值：</p>
                <p class="p3">￥0</p>
              </div>
              <div style="display: flex; align-items: center">
                <p class="p3 p4">钱包余额：</p>
                <p class="p3">￥{{ balanceObj.balance + balanceObj.lockBalance }}</p>
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <p class="p3 p4">员工人数：</p>
              <p class="p3">6人</p>
            </div>
          </div>
          <el-button size="small" class="btns" plain>充值</el-button>
        </div>
        <div style="display: flex; justify-content: center">
          <el-button class="btns1" type="primary">推荐地接360给同业好友 可得20元优惠券<i
              class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
      </div>
      <div class="right">
        <div class="rightblock" v-for="(item, index) in blockList" :key="index">
          <p class="p1">
            {{ item.num }}<span>{{ item.dan }}</span>
          </p>
          <p class="p2">{{ item.title }}</p>
        </div>
      </div>
    </footer>
    <modifyPasswordPopup ref="modifyPasswordPopup"></modifyPasswordPopup>
    <reorganizationPopup ref="rechargePopup"></reorganizationPopup>
  </div>
</template>

<script>
import modifyPasswordPopup from "../modifyPasswordPopup";
import reorganizationPopup from "../reorganizationPopup.vue";
import PayApi from '@/components/Api/pay.js'
export default {
  components: {
    modifyPasswordPopup,
    reorganizationPopup,
  },
  data() {
    return {
      balanceObj: {},//渲染的余额的数据
      dialogVisible1: false,
      blockList: [
        {
          title: "我的订单",
          key: "",
          num: 0,
          dan: "个",
        },
        {
          title: "我的方案",
          key: "",
          num: 0,
          dan: "",
        },
        {
          title: "我发出的询单",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我抢到的询单",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我的用户",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我的分销",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我的粉丝",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我的关注",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我喜欢的",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我的活动",
          key: "",
          num: 0,
          dan: null,
        },
        {
          title: "我的优惠券",
          key: "",
          num: 0,
          dan: "张",
        },
        {
          title: "我的积分",
          key: "",
          num: 0,
          dan: null,
        },
      ],
    };
  },
  computed: {
    type(flag) {
      return flag ? "text" : "password";
    },
    elIcon(flag) {
      return flag ? "el-icon-minus" : "el-icon-view";
    },
  },
  watch: {},
  methods: {
    //获取钱包余额
    getWalletTotal() {
      new PayApi("pay",)
        .walletTotal({}, 'GET')
        .then((res) => {
          console.log(res, '看看接口返回的数据');
          if (res.status == 200) {
            this.balanceObj = res.data
          } else {
            this.$message.error(res.statusText);
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "系统异常!",
          });
        });
    },
    //修改密码弹框
    handlerModifyPasswordClick() {
      this.$refs.modifyPasswordPopup.init();
    },
    //改绑申请
    handlerModifyApplyClick() {
      this.$refs.rechargePopup.init();
    },
  },
  created() { },
  mounted() { 
    this.getWalletTotal()
  },
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    height: 3rem;
    width: 100%;
    border-radius: 0.1rem;
    background-color: rgba(255, 255, 255, 1);
    color: rgba(16, 16, 16, 1);
    font-size: 0.14rem;
    padding: 0.2rem 0.5rem 0 0.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.29rem;

    .p1 {
      color: rgba(31, 124, 105, 1);
      font-size: 0.2rem;
      font-family: SourceHanSansSC-regular;
      margin-bottom: 0.26rem;
    }

    .p2 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.12rem;

      .span1 {
        color: rgba(16, 16, 16, 1);
        font-size: 0.16rem;
        font-family: SourceHanSansSC-regular;
      }

      .span2 {
        color: rgba(50, 189, 254, 1);
        font-size: 0.16rem;
        font-family: SourceHanSansSC-regular;
        cursor: pointer;
      }
    }

    .leftBox {
      flex: 1;
      height: 100%;
      margin-right: 1.3rem;

      .p3 {
        color: rgba(16, 16, 16, 1);
        font-size: 0.16rem;
        font-family: SourceHanSansSC-regular;

        span {
          color: #ee744c;
        }
      }

      .p4 {
        color: rgba(58, 98, 215, 1);
        font-size: 0.22rem;
        font-family: SourceHanSansSC-bold;
        border-bottom: 1px solid rgba(58, 98, 215, 1);
        cursor: pointer;
        font-weight: bold;
      }
    }

    .rightBox {
      flex: 1;
      height: 100%;
    }
  }

  .footer {
    display: flex;
    align-items: center;

    .left {
      flex: 1;
      height: 3rem;
      border-radius: 0.25rem 0 0 0;
      background-color: rgba(243, 243, 243, 1);
      border: 0.06rem solid rgba(255, 255, 255, 1);
      padding: 0.27rem 0.3rem;

      .btns {
        background-color: rgba(255, 255, 255, 1);
        color: rgba(197, 59, 9, 1);
        font-size: 0.2rem;
        font-family: SourceHanSansSC-bold;
        border: none;
        width: 1rem;
      }

      .lineBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.1rem;

        .line1 {
          display: flex;
          align-items: center;

          .p1 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.2rem;
            text-align: left;
            font-family: SourceHanSansSC-regular;

            span {
              color: rgba(16, 16, 16, 1);
              font-size: 0.14rem;
              font-family: SourceHanSansSC-regular;
            }
          }

          .p2 {
            color: rgba(16, 16, 16, 1);
            font-size: 0.12rem;
            font-family: SourceHanSansSC-regular;
          }
        }

        .p3 {
          color: rgba(16, 16, 16, 1);
          font-size: 0.16rem;
          font-family: SourceHanSansSC-regular;
        }

        .p4 {
          width: 1rem;
        }
      }

      .btns1 {
        width: 6rem;
        height: 0.38rem;
        border-radius: 0.2rem;
        background-color: rgba(197, 59, 9, 1);
        text-align: center;
        box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.13);
      }
    }

    .right {
      padding: 0.4rem 0.8rem;
      flex: 1;
      height: 3rem;
      background-color: rgba(255, 255, 255, 1);
      border: 0.06rem solid rgba(255, 255, 255, 1);
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .rightblock {
        width: 1.5rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .p1 {
          font-size: 0.25rem;
          color: #000;

          span {
            font-size: 0.12rem;
          }
        }

        .p2 {
          font-family: "\9ED1\4F53";
          font-size: 0.12rem;
          color: #909396;
        }
      }
    }
  }
}
</style>
